import { sizeOptionsOrDefault } from './utils';
import { MultiPathShape } from './MultiPathShape';
const defaultOptions = {
    ellipseRadiusXRatio: 0.165,
    ellipseRadiusYRatio: 0.5
};
/**
 * A visual element that renders a data storage symbol with curved sides.
 * Extends MultiPathShape and provides functionality for creating storage device shapes.
 */
export class DataStorage extends MultiPathShape {
    /**
     * Creates a new DataStorage instance.
     * @param options Configuration options for the data storage shape
     */
    constructor(options) {
        super({ ...defaultOptions, ...options });
    }
    /** @hidden */
    _drawPath() {
        const drawingElement = this.drawingElement;
        const { width, height } = sizeOptionsOrDefault(this.options);
        const ellipseRX = width * this.options.ellipseRadiusXRatio;
        const rx = ellipseRX;
        const ry = height * this.options.ellipseRadiusYRatio;
        const leftCx = ellipseRX;
        drawingElement
            .moveTo(leftCx, 0)
            .lineTo(width, 0)
            .arc(270, 90, rx, ry, true)
            .lineTo(leftCx, height)
            .arcTo([leftCx, 0], rx, ry, false, true)
            .close();
    }
}
